import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaceForms2Module } from '@evorait/pace-forms';
import { DetailsModule } from '../details/details.module';
import { SharedModule } from '../shared/shared.module';
import { FormsListWrapperComponent } from './components/forms2-list/forms-list-wrapper.component';
import { Forms2WrapperComponent } from './components/forms2-wrapper/forms2-wrapper.component';

@NgModule({
    declarations: [Forms2WrapperComponent, FormsListWrapperComponent],
    imports: [CommonModule, PaceForms2Module.forChild(), SharedModule, DetailsModule],
    exports: [Forms2WrapperComponent, FormsListWrapperComponent],
})
export class PaceForms2WrapperModule {}
